<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.farm') }} *</label>
            <br />
            <el-select
              clearable
              @change="hideView"
              filterable
              class="select-primary custom-width-select shadow-sm farm-form"
              size="large"
              v-model="waterForm.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
              v-validate="modelValidations.farm_id"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <br class="media-none" />
            <label>{{ $t('common_words.date') }}</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              @change="hideView"
              :picker-options="pickerOptions"
              class="shadow-sm date-form"
              v-model="waterForm.date"
              type="date"
              range-separator="-"
              value-format="yyyy-MM-dd"
              :placeholder="`${$t('common_words.select')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-6 col-md-4 col-lg-4 col-xl-6">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.generate')
            }}</label
            ><br />
            <button
              style="margin-right: 10px"
              class="btn btn-info btn-fg"
              @click.prevent="generate"
            >
              <i class="fa fa-list-alt"></i> {{ $t('common_words.generate') }}
            </button>
            <button class="btn btn-info btn-fg" @click.prevent="preload">
              <i class="fa fa-table"></i> {{ $t('common_words.preload') }}
            </button>
          </div>
        </div>
        <br />
      </card>
      <card class="custom-shadow-card-header" v-if="showPreload">
        <form>
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <div class="form-group has-label">
                  <el-upload
                    drag
                    ref="upload"
                    :action="getAxiosURL() + '/auth/waters/waters/preload'"
                    :data="{ farm_id: waterForm.farm_id, date: formatDate }"
                    :headers="headerInfo"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :on-success="handleSuccess"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :auto-upload="false"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      {{ $t('common_words.finished_format') }}
                      <em> {{ $t('common_words.click_to_load') }}</em>
                    </div>
                    <div slot="tip" class="el-upload__tip">
                      {{ $t('common_words.xlsx_notice') }}
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="text-center" v-if="isCreate()">
                <button
                  style="margin-right: 10px"
                  class="btn btn-info btn-fg"
                  @click.prevent="downloadFormat"
                >
                  <i class="fa fa-file-excel-o"></i>
                  {{ $t('common_words.download_file') }}
                </button>
                <button
                  class="btn btn-info btn-fg"
                  @click.prevent="submitUpload"
                >
                  <i class="fa fa-plus"></i>
                  {{ $t('common_words.download_file') }}
                </button>
              </div>
            </div>
          </div>
        </form>
        <br />
      </card>
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="showTable"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="table-responsive">
              <table class="table table-striped table-bordered not-last-td">
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('samples.water_source') }}
                    </th>
                    <th
                      scope="col"
                      v-for="(row, i) in waterForm.nutrientColumns"
                      class="text-center p-3 custom-header-label"
                      :key="i"
                    >
                      {{ row.label }} <br />
                      <span class="custom-unit-label" v-if="row.unit">{{
                        row.unit
                      }}</span>
                    </th>
                    <th
                      scope="col"
                      class="text-center p-3 custom-header-label sticky-col-th"
                    >
                      {{ $t('common_words.operations') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(p, i) in waterForm.nWater" :key="i">
                    <td class="text-center" style="min-width: 200px">
                      <el-select
                        clearable
                        @clear="clearWaterSourceSelect(i)"
                        filterable
                        style="width: 70%; margin: auto"
                        class="select-primary custom-width-select required-water_sources shadow-sm"
                        size="large"
                        v-model="waterForm.water_sources_sel[i]"
                        @change="changeArray(i)"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="l in availableWaterSources"
                          class="select-primary"
                          :value="l.id"
                          :label="l.name"
                          :key="l.id"
                        ></el-option>
                      </el-select>
                    </td>
                    <td
                      v-for="(column, index) in waterForm.nutrientColumns"
                      class="text-center"
                      style="min-width: 100px"
                      :key="index"
                    >
                      <el-input
                        type="number"
                        min="0"
                        max="9999"
                        style="width: 100px"
                        class="shadow-sm text-center required-inputs"
                        :class="
                          column.type == 'Textura' ? 'required-textures' : ''
                        "
                        pattern="/^-?\d+\.?\d*$/"
                        onKeyPress="if(this.value.length==4) return false;"
                        :disabled="disables[i]"
                        v-model="
                          waterForm.inputs[
                            waterForm.water_sources_sel[i] + '-' + column.prop
                          ]
                        "
                      />
                    </td>
                    <td
                      class="text-center vertical-custom sticky-col-td"
                      style="display: table-cell"
                    >
                      <div class="d-flex justify-content-center mt-3">
                        <a
                          v-if="
                            isUpdate() &&
                            waterForm.nWater < water_sources.length
                          "
                          v-tooltip.top-center="$t('common_words.add')"
                          class="btn-warning btn-simple btn-link custom-margin-actions"
                          @click="addRowTable(i)"
                        >
                          <em class="fa fa-plus custom-size-fa-actions"></em>
                        </a>
                        <a
                          v-if="waterForm.nWater > 1 && isDelete()"
                          v-tooltip.top-center="$t('common_words.erase')"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="
                            handleDelete(waterForm.water_sources_sel[i], i)
                          "
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-12 mt-5">
              <div class="row">
                <div class="col-6 text-right">
                  <button
                    class="btn btn-fill btn-info btn-wd shadow-sm"
                    @click="validateForm"
                  >
                    {{ $t('common_words.save_data') }}
                  </button>
                </div>
                <div class="col-6">
                  <button
                    class="btn btn-fill btn-danger btn-wd shadow-sm"
                    @click="DeleteAll"
                  >
                    {{ $t('common_words.delete') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import moment from 'moment';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  data() {
    return {
      waterForm: {
        farm_id: null,
        date: moment().format('YYYY-MM-DD'),
        nWater: 1,
        water_sources_sel: [],
        inputs: {},
        inputs_bck: {},
        user_id: this.$store.state.auth.user.id,
      },
      old_water_sources_sel: [],
      totals: {},
      tableWeekColumns: [],
      showTable: false,
      showPreload: false,
      farms: null,
      disables: [],
      water_sources: null,
      firstColumn: null,
      secondColum: null,
      firstElement: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
      },
      fileList: [],
      modelValidations: {
        farm_id: {
          required: true,
        },
      },
    };
  },

  computed: {
    availableWaterSources() {
      return this.water_sources.filter(
        (water_source) =>
          !this.waterForm.water_sources_sel.includes(water_source.id)
      );
    },

    formatDate() {
      return moment(this.waterForm.date).format('YYYY-MM-DD');
    },
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinNotification,
    MixinExport,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    clearWaterSourceSelect(index) {
      this.waterForm.water_sources_sel[index] = null;
      this.disables[index] = true;
    },

    changeArray(index) {
      if (typeof this.old_water_sources_sel[index] !== 'undefined') {
        for (const key in this.waterForm.inputs) {
          let split = key.split('-');
          if (split[0] == this.old_water_sources_sel[index]) {
            this.$set(
              this.waterForm.inputs,
              this.waterForm.water_sources_sel[index] + '-' + split[1],
              this.waterForm.inputs[key]
            );
            delete this.waterForm.inputs[split[0] + '-' + split[1]];
          }
        }

        delete this.totals[this.old_water_sources_sel[index]];
      }

      if (
        this.waterForm.water_sources_sel[index] != null &&
        this.waterForm.water_sources_sel[index] != null
      ) {
        this.disables[index] = false;
      }

      this.old_water_sources_sel = Object.assign(
        [],
        this.waterForm.water_sources_sel
      );
    },

    addRowTable(index) {
      this.waterForm.nWater++;
      this.disables[this.waterForm.nWater - 1] = true;
      this.disables['undefined'] = true;
    },

    hideView() {
      this.showTable = false;
      this.showPreload = false;
    },

    cleanView() {
      this.waterForm.water_sources_sel = [];
      this.waterForm.inputs = {};
      this.waterForm.inputs_bck = {};
      this.waterForm.inputs_ids = {};
      this.tableWeekColumns = [];
      this.disables = [];
      this.totals = {};
    },

    validateFilter() {
      this.waterForm.id = null;

      if (this.waterForm.farm_id.length == 0) {
        this.highlightItem('farm-form');

        return false;
      } else if (this.waterForm.date == null) {
        this.highlightItem('date-form');

        return false;
      } else {
        return true;
      }
    },

    generate() {
      this.cleanView();
      this.waterForm.id = null;

      if (this.validateFilter()) {
        this.showHideLoading(true);

        this.waterForm.route = 'waters/waters';
        //this.waterForm.date = moment(this.waterForm.date).format("YYYY-MM-DD"),

        Axios.getMasters('waters/sources/' + this.waterForm.farm_id)
          .then((r1) => {
            Axios.saveMaster(this.waterForm)
              .then((r2) => {
                this.water_sources = r1.data.data;
                this.waterForm.nWater = r2.data.nWater;
                this.waterForm.nutrientColumns = r2.data.nutrientColumns;

                if (typeof r2.data.id !== 'undefined') {
                  this.waterForm.id = r2.data.id;
                } else {
                  this.disables[0] = true;
                }

                if (r2.data.water_sources_sel.length > 0) {
                  this.waterForm.water_sources_sel = r2.data.water_sources_sel;
                  this.waterForm.water_sources_sel_bck = Object.assign(
                    [],
                    this.waterForm.water_sources_sel
                  );
                  this.old_water_sources_sel = Object.assign(
                    [],
                    this.waterForm.water_sources_sel
                  );

                  try {
                    this.waterForm.water_sources_sel = [];
                    setTimeout(() => {
                      this.waterForm.water_sources_sel = Object.assign(
                        [],
                        this.waterForm.water_sources_sel_bck
                      );
                    }, 5);
                  } catch (error) {}
                } else {
                  this.disables['undefined'] = true;
                }

                if (Object.keys(r2.data.inputs).length) {
                  this.waterForm.inputs = r2.data.inputs;
                  this.waterForm.inputs_bck = Object.assign(
                    {},
                    this.waterForm.inputs
                  );
                  this.waterForm.inputs_ids = r2.data.inputs_ids;
                }

                this.showTable = true;
                this.showPreload = false;
                this.showHideLoading();
              })
              .catch((error) => console.log(error));
          })
          .catch((error) => console.log(error));
      }
    },

    preload() {
      this.cleanView();
      this.waterForm.id = null;

      if (this.validateFilter()) {
        this.showTable = false;
        this.showPreload = true;
      }
    },

    handleDelete(index, i) {
      if (typeof index !== 'undefined' && index != null) {
        try {
          let index1 = this.waterForm.water_sources_sel.findIndex(
            (water_source) => water_source === index
          );

          this.waterForm.water_sources_sel.splice(index1, 1);
          delete this.totals[index];

          let tmp = Object.assign([], this.waterForm.water_sources_sel);
          this.waterForm.water_sources_sel = [];
          setTimeout(() => {
            this.waterForm.water_sources_sel = Object.assign([], tmp);
            this.old_water_sources_sel = Object.assign([], tmp);
          }, 5);
        } catch (error) {}

        try {
          for (const key in this.waterForm.inputs) {
            let split = key.split('-');

            if (split[0] == index) {
              delete this.waterForm.inputs[key];
            }
          }
        } catch (error) {}
      } else {
        try {
          this.waterForm.water_sources_sel.splice(i, 1);

          let tmp = Object.assign([], this.waterForm.water_sources_sel);
          this.waterForm.water_sources_sel = [];
          setTimeout(() => {
            this.waterForm.water_sources_sel = Object.assign([], tmp);
            this.old_water_sources_sel = Object.assign([], tmp);
          }, 5);
        } catch (error) {}

        try {
          for (const key in this.waterForm.inputs) {
            let split = key.split('-');

            if (split[0] === 'undefined') {
              delete this.waterForm.inputs[key];
            }
          }
        } catch (error) {}
      }

      try {
        this.disables.splice(i, 1);
      } catch (error) {}

      this.waterForm.nWater--;
    },

    validateForm() {
      let passed = true;
      let amount_texture = 0;

      this.waterForm.water_sources_sel.forEach((lot_id) => {
        let count = 0;

        for (const key in this.waterForm.inputs) {
          let split = key.split('-');
          let index_nutrient = this.waterForm.nutrientColumns.findIndex(
            (column) => column.prop === Number(split[1])
          );

          if (split[0] == lot_id) {
            if (
              this.waterForm.inputs[key] != '' &&
              this.waterForm.inputs[key] != null
            ) {
              if (
                this.waterForm.nutrientColumns[index_nutrient].type == 'Textura'
              ) {
                amount_texture += parseFloat(this.groundForm.inputs[key]);
              }

              count++;
            }

            if (
              this.waterForm.inputs[key] != '' &&
              this.waterForm.inputs[key] != null &&
              parseFloat(this.waterForm.inputs[key]) == 0
            ) {
              count = 0;
              break;
            }
          }
        }

        if (count == 0) {
          passed = false;
        }
      });

      if (this.waterForm.nWater != this.waterForm.water_sources_sel.length) {
        return this.validationInputsRequired('water_sources');
      } else if (
        passed == false ||
        Object.keys(this.waterForm.inputs).length == 0
      ) {
        SweetAlert.warning(i18n.t('sweet_alert.water.missing_inputed_info'));
      } else {
        if (!this.validateArrayField('water_sources_sel')) {
          return this.validationInputsRequired('water_sources', true);
        } else {
          this.storeUpdateLeaf();
        }
      }
    },

    validateArrayField(field) {
      let passed = true;

      this.waterForm[field].forEach((elem) => {
        if (
          elem == null ||
          elem == '' ||
          (elem != '' && elem != null && parseFloat(elem) == 0) ||
          typeof elem == 'undefined'
        ) {
          passed = false;
        }
      });

      return passed;
    },

    storeUpdateLeaf() {
      this.showHideLoading(true);

      if (this.isCreate() || this.isUpdate()) {
        this.waterForm.route = 'waters/waters/store';
        Axios.saveMaster(this.waterForm)
          .then((response) => {
            this.waterForm.water_sources_sel_bck = Object.assign(
              [],
              this.waterForm.water_sources_sel
            );
            this.waterForm.inputs_bck = Object.assign(
              {},
              this.waterForm.inputs
            );
            this.old_water_sources_sel = Object.assign(
              [],
              this.waterForm.water_sources_sel
            );

            if (typeof response.data.data.id !== 'undefined') {
              this.waterForm.id = response.data.id;
            }

            if (Object.keys(response.data.data.inputs_ids).length) {
              this.waterForm.inputs_ids = response.data.data.inputs_ids;
            }

            this.showHideLoading();
            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-settings-90',
              i18n.t('common_words.success_operation')
            );
            this.showTable = false;
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    DeleteAll() {
      SweetAlert.delete(this.waterForm.date).then((result) => {
        if (result.value) {
          this.showHideLoading(true);
          if (this.waterForm.id && this.isDelete()) {
            this.waterForm.route = 'waters/waters';

            Axios.destroyMaster(this.waterForm)
              .then((response) => {
                this.cleanView();
                this.waterForm.nWater = 1;
                this.showHideLoading();
                this.showNotification(
                  `${response.data.message}`,
                  'success',
                  'nc-settings-90',
                  i18n.t('common_words.successful_deletion')
                );
              })
              .catch((error) => this.showMessageErrors(error));
          } else {
            if (!this.isDelete()) {
              this.showMessageAccess();
            } else {
              this.showHideLoading();
            }
          }
        }
      });
    },

    handleExceed(files, fileList) {
      SweetAlert.warning(
        `${i18n.t('sweet_alert.ground.selected_limit')} ${
          files.length
        } ${i18n.t('sweet_alert.ground.files')}`
      );
    },

    handleSuccess(res, file) {
      if (res.errors) {
        let html = ``;
        res.errors.forEach((error) => {
          html += `<p> ${error} </p>`;
        });
        SweetAlert.danger(html);
      } else {
        this.generate();
      }

      this.$refs.upload.clearFiles();
      this.showHideLoading();
    },

    beforeUpload(file) {
      this.waterForm.date = moment(this.waterForm.date).format('YYYY-MM-DD');
    },

    submitUpload() {
      this.$refs.upload.submit();
    },

    downloadFormat() {
      let self = this;
      let data = self.waterForm;
      data.route = 'waters/waters/preformat';
      data.name_file = 'precarga_aguas.xlsx';
      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
  },

  created() {
    this.showHideLoading(true);

    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('farms/farms/only')
        .then((r) => {
          this.farms = r.data.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrorsSwalAlert(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('waters/nutrients');
  },

  destroyed() {
    this.deselectedItemOnMenu('waters/nutrients');
  },
};
</script>
<style scoped>
.table-journals td:empty {
  visibility: hidden;
}

.table-journals td:blank {
  visibility: hidden;
}

/* .sticky-column {
  position: absolute;
  z-index: 100;
  height: 100%;
  background: #f8fcfe;
  box-shadow: 5px 0px 5px rgba(195, 209, 226, 0.2),
    0px -1px 0px rgba(195, 209, 226, 1);
} */

.sticky-col-td {
  position: sticky;
  right: 0;
  background-color: #f8fcfe;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
  min-width: 130px;
}

.sticky-col-th {
  position: sticky;
  right: 0;
  background-color: #888888;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
  min-width: 100px;
}

.custom-unit-label {
  text-transform: none;
}
</style>
